module.exports = __webpack_public_path__ + "img/Feature.302d504c.jpg";